import _axios from 'axios';
import {
  nprogressErrorInterceptorV2,
  nprogressRequestInterceptorV2,
  nprogressResponseInterceptorV2
} from './axios-loading.interceptor.v2';

export const axios = _axios;

// interceptor to display nprogress (v2 for Axios 1.x frontend)
axios.interceptors.request.use(
  nprogressRequestInterceptorV2,
  nprogressErrorInterceptorV2
);
axios.interceptors.response.use(
  nprogressResponseInterceptorV2,
  nprogressErrorInterceptorV2
);
